<template>
    <span class="icon icon_required">
        <svg viewBox="0 0 36 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M1 10C1 4.47715 5.47715 0 11 0H25C30.5228 0 35 4.47715 35 10V10C35 15.5228 30.5228 20 25 20H11C5.47715 20 1 15.5228 1 10V10Z"
                  fill="#FFEFED"/>
            <path
                d="M17.36 14.724V13.69H11.893V13.096H17.085V10.544H10.595V11.567H15.809V12.161H10.606V14.724H17.36ZM15.149 9.697L15.05 8.729C14.687 8.795 14.214 8.839 13.653 8.883L13.873 7.123C13.455 7.101 13.048 7.046 12.641 7.002L12.531 8.938C12.19 8.96 11.805 8.971 11.42 8.982C11.376 8.311 11.332 7.662 11.31 7.002C10.881 7.046 10.463 7.101 10.045 7.134C10.122 7.75 10.188 8.377 10.276 9.004H9L9.165 10.049C11.211 10.049 13.807 9.961 15.149 9.697ZM17.085 10.038V5H15.809V10.038H17.085ZM14.775 6.573V5.561H9.33V6.573H14.775Z"
                fill="#FF5C5C"/>
            <path
                d="M23.5556 14.812V11.325H27.3616V10.313H18.5066V11.325H22.2576V14.812H23.5556ZM26.9986 8.454C25.4256 8.311 23.6216 7.178 23.6216 5.715V5.209H22.2576V5.715C22.2576 7.178 20.6076 8.267 18.9136 8.454L19.4636 9.51C20.9486 9.268 22.5106 8.344 22.9396 7.266C23.4236 8.344 24.9856 9.279 26.4376 9.499L26.9986 8.454Z"
                fill="#FF5C5C"/>
        </svg>
    </span>
</template>

<script lang="ts">
export default {
    name: 'IconRequired',
};
</script>

<style scoped lang="scss">
.icon_required {
    display: inline-block;
    vertical-align: middle;
    font-size: 0;
    width: 34px;
    height: 20px;

    svg {
        width: 100%;
        height: 100%;
    }
}
</style>
